export default __webpack_public_path__ + "static/media/Altaport_Services_Agreement_PT.73851d77.pdf";